const IMAGE_WIDTHS = {
  "/images/about/family-strip.webp": 523,
  "/images/about/hero-1.webp": 1500,
  "/images/about/hero-2.webp": 1500,
  "/images/about/hero-3.webp": 1500,
  "/images/deck/slide-01.webp": 1800,
  "/images/deck/slide-02.webp": 1800,
  "/images/deck/slide-03.webp": 1800,
  "/images/deck/slide-04.webp": 1800,
  "/images/deck/slide-05.webp": 1800,
  "/images/deck/slide-06.webp": 1800,
  "/images/deck/slide-07.webp": 1800,
  "/images/deck/slide-08.webp": 1800,
  "/images/deck/slide-09.webp": 1800,
  "/images/deck/slide-10.webp": 1800,
  "/images/deck/slide-11.webp": 1800,
  "/images/deck/slide-12.webp": 1800,
  "/images/deck/slide-13.webp": 1800,
  "/images/deck/slide-14.webp": 1800,
  "/images/deck/slide-15.webp": 1800,
  "/images/deck/slide-16.webp": 1800,
  "/images/deck/slide-17.webp": 1800,
  "/images/deck/slide-18.webp": 1800,
  "/images/deck/slide-19.webp": 1800,
  "/images/deck/slide-20.webp": 1800,
  "/images/home/hero.webp": 2400,
  "/images/lisse/hero.webp": 2000,
  "/images/off-deck/slide-01.webp": 1800,
  "/images/off-deck/slide-02.webp": 1800,
  "/images/off-deck/slide-03.webp": 1800,
  "/images/off-deck/slide-04.webp": 1800,
  "/images/off-deck/slide-05.webp": 1800,
  "/images/off-deck/slide-06.webp": 1800,
  "/images/off/hero.webp": 2000,
  "/images/off/overlay.webp": 1346,
  "/images/off/product.webp": 1334,
  "/images/oldfriends/1900-back.webp": 2000,
  "/images/oldfriends/abair.webp": 1440,
  "/images/oldfriends/beanie-red.webp": 2000,
  "/images/oldfriends/chicasso-back.webp": 2000,
  "/images/oldfriends/cholo-back.webp": 2000,
  "/images/oldfriends/cholo-front.webp": 2000,
  "/images/oldfriends/curb-hat.webp": 2000,
  "/images/oldfriends/fannie-hat.webp": 2000,
  "/images/oldfriends/legs-back.webp": 2000,
  "/images/oldfriends/lipstick-back.webp": 2000,
  "/images/oldfriends/lipstick-front.webp": 2000,
  "/images/oldfriends/nice-day-back.webp": 2000,
  "/images/oldfriends/nice-day-front.webp": 2000,
  "/images/oldfriends/park-legs.webp": 2000,
  "/images/oldfriends/pt-blue.webp": 2000,
  "/images/oldfriends/pt-pack-hero.webp": 2100,
  "/images/oldfriends/pt-pack.webp": 2000,
  "/images/oldfriends/pt-purple.webp": 2000,
  "/images/oldfriends/pt-trio-card.webp": 1600,
  "/images/oldfriends/pt-trio-hero.webp": 2100,
  "/images/oldfriends/roses-back.webp": 2000,
  "/images/oldfriends/roses-front.webp": 2000,
  "/images/oldfriends/sidebag-1.webp": 2000,
  "/images/oldfriends/sidebag-2.webp": 2000,
  "/images/oldfriends/tech-better-together.webp": 1600,
  "/images/oldfriends/tech-hippy-skippy.webp": 1600,
  "/images/oldfriends/tom-back.webp": 2000,
  "/images/oldfriends/tom-front.webp": 2000,
  "/images/oldfriends/wof-back.webp": 2000,
  "/images/runrs/hero.webp": 2000,
  "/images/runrs/home-trio-left.webp": 999,
  "/images/runrs/home-trio-right.webp": 561,
  "/images/runrs/lifestyle-2.webp": 1500,
  "/images/runrs/lifestyle-3.webp": 951,
  "/images/runrs/lifestyle-4.webp": 1500,
  "/images/runrs/lifestyle-5.webp": 1500,
  "/images/runrs/product-1.webp": 1500,
  "/images/runrs/product-3.webp": 1500,
  "/images/runrs/product-4.webp": 1500,
  "/images/runrs/product-5.webp": 1500,
  "/images/signpainting/bar-grill.webp": 1512,
  "/images/signpainting/bay-views.webp": 1448,
  "/images/signpainting/brushwork.webp": 1512,
  "/images/signpainting/demon-mirror.webp": 1512,
  "/images/signpainting/donut-bar.webp": 1440,
  "/images/signpainting/door-process.webp": 1430,
  "/images/signpainting/food-city.webp": 1512,
  "/images/signpainting/geisha.webp": 1512,
  "/images/signpainting/iron-ink.webp": 1440,
  "/images/signpainting/la-hacienda-hero.webp": 2100,
  "/images/signpainting/la-hacienda.webp": 1511,
  "/images/signpainting/la-tattoo.webp": 1024,
  "/images/signpainting/midtown-detail.webp": 1512,
  "/images/signpainting/midtown-storefront.webp": 1512,
  "/images/signpainting/panther.webp": 1512,
  "/images/signpainting/poker-room.webp": 1512,
  "/images/signpainting/rose-glass.webp": 1512,
  "/images/signpainting/scala-osteria.webp": 2000,
  "/images/signpainting/taco-cantina.webp": 1512,
  "/images/signpainting/truck-lettering.webp": 2000,
  "/images/signpainting/walk-ins.webp": 2000,
  "/images/signpainting/wine-co-mural.webp": 1512,
  "/images/signpainting/world-peace-action.webp": 1440,
  "/images/signpainting/world-peace.webp": 1280
};

export default IMAGE_WIDTHS;

export const responsiveImg = (src, sizes) => {
  const w = IMAGE_WIDTHS[src];
  if (!w || w <= 900) return { src };
  return {
    src,
    srcSet: `${src.replace(/\.webp$/, "-sm.webp")} 800w, ${src} ${w}w`,
    sizes,
  };
};
